/* src/app/shared/invoice/retired/headers/retired-aud.css */
span {
  padding: .25em 0;
  display: inline-block;
}
/*# sourceMappingURL=retired-aud.css.map */
